import { useQuery } from "@tanstack/react-query";
import { getUnreadCount } from "../api/notification-centre-api";
import { NOTIFICATION_CENTRE_QUERY_KEYS } from "../constants/query-keys";

export const useUnreadCount = (enabled: boolean) => {
	return useQuery({
		queryKey: NOTIFICATION_CENTRE_QUERY_KEYS.unreadCount(),
		queryFn: getUnreadCount,
		enabled,
		select: (data) => data.unread_count,
	});
};
